import React from 'react'
import { useEffect,useState } from 'react';
import { RiHistoryLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import Modal from './Logout';

const MainHeader = () => {
  
  let id = localStorage.getItem('username');
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  
  useEffect(() => {
    // console.log(id);
    if(!id){
      navigate("/login");
    }

  }, [])
  

  return (
  <>
    <div className='flex justify-between m-4 px-44'>
        <a href="/"><h1 className='font-bold text-3xl text-xgreen'>Che<span className='text-xpurple'>X</span>care</h1></a>
        <div className='flex items-center'>
          <a href='/history' className='p-[7px] w-[36px] h-[36px] bg-xgreen rounded-2xl mr-2'><RiHistoryLine className='text-xl text-white'/></a>
          <div className='w-[36px] h-[36px] flex justify-center items-center bg-xgreen rounded-2xl'><button onClick={openModal}>{id && <h5 className=' font-bold text-white'>{id[0].toUpperCase()}</h5>}</button></div>
        </div>
    </div>
    <Modal isOpen={isOpen} onClose={closeModal}>
        <div className='p-4'>
        <h2 className="text-xl text-xpurple font-bold mb-4">LogOut </h2>
        <p className='font-semibold italic'>hey {id}, Do you want to logout?</p>
        </div>
      </Modal>
    
  </>
  )
}


export default MainHeader